<template>
  <v-card v-if="loaded()">
    <v-card-title class="headline">Delete Confirmation</v-card-title>
    <v-card-text>
      <div>
        Are you sure you want to delete the question
        <span class="font-weight-bold">"{{ record.text }}"</span>
      </div>
      <div class="mt-2">
        <span class="font-weight-bold">Note:</span> If a question is associated
        with a Primary Role or Answers in the Admin section, it cannot be
        deleted, only deprecated.
      </div>
      <div class="mt-2">
        Deprecated questions will remain in the database but will not be shown
        in the Primary Role dropdown or the User Security form in the Build
        section.
      </div>
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn outlined @click="cancel" class="mr-2">Cancel</v-btn>
      <v-btn color="warning elevation-0 font-weight-bold" @click="submit"
        >Delete</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  computed: {
    record() {
      return this.$store.state[this.entityType].record;
    },
  },
  data() {
    return {};
  },
  methods: {
    cancel() {
      this.$emit("setDialog", false);
    },
    loaded() {
      return this.record;
    },
    async submit() {
      try {
        await this.$store.dispatch(`${this.entityType}/remove`, this.entityId);
        this.$emit("setDialog", false);
      } catch (e) {
        // eslint-disable-next-line
        console.error(e);
        if (e.message === "Request failed with status code 409") {
          return this.$notifyError({
            message: `This question could not be deleted because it is in use. Deprecate the question instead.`,
            timeout: 0,
          });
        }
        this.$notifyError({
          message: `Could not delete this question.`,
        });
      }
    },
  },
  props: ["entityType", "entityId"],
};
</script>
